import React, { memo } from 'react';
import DynamicIcon from './DynamicIcon';

const EmptyState = memo(({ darkMode }) => (
  <div className={`text-center py-12 px-4 rounded-xl ${
    darkMode 
      ? 'bg-[#1a1823] border border-slate-700/50 text-slate-400' 
      : 'bg-white border border-slate-200 text-slate-700'
  } shadow-lg animate-scale-in`}>
    <div className={`inline-flex items-center justify-center w-20 h-20 rounded-full ${
      darkMode ? 'bg-blue-500/10' : 'bg-blue-100'
    } mb-4`}>
      <DynamicIcon name="folder" darkMode={darkMode} className="h-10 w-10" />
    </div>
    <h3 className={`text-xl font-medium ${
      darkMode ? 'text-slate-200' : 'text-slate-800'
    } mb-2 font-medium`}>
      Empty Folder
    </h3>
    <p className={darkMode ? 'text-slate-400' : 'text-slate-500'}>
      This folder doesn't contain any files or folders.
    </p>
  </div>
));

export default EmptyState;
